import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { HREF, OverlayService } from '@core';

@Component({
  selector: 'lib-session-expired',
  templateUrl: './session-expired.component.html',
  styleUrls: ['./session-expired.component.scss'],
  imports: [MatButtonModule, MatIconModule, MatCardModule],
})
export class SessionExpiredComponent {
  readonly overlayService = inject(OverlayService);
  private readonly router = inject(Router);

  closeOverlay(): void {
    this.overlayService.close();
  }

  continueClick(): void {
    this.closeOverlay();
    this.router.navigate(['/', HREF.NOT_FOUND]);
  }
}
